/** @format */

import React, { ReactNode, useEffect } from 'react';
import { safeUrl } from '@services/drupal-services';
import { startLazyLoad } from '@varian/scripts/services/lazy-load';

interface FeaturedProps {
  children?: ReactNode;
  description?: string;
  title?: string;
  image?: Record<string, string>;
  link?: string;
  linkText?: string;
}

/**
 * Featured Menu Item.
 */
const FeaturedMenuItem = (props: FeaturedProps): JSX.Element => {
  const { description, title, link, linkText, image } = props;

  /**
   * Lazy load featured image.
   */
  useEffect(() => {
    setTimeout(() => startLazyLoad(), 50);
  }, []);

  /**
   * Render.
   */
  return (
    <a href={safeUrl(link)}>
      <div className="featured-menu-item">
        <div
          className="featured-menu-image small-rounded-corners
          ">
          <img
            className="lazy"
            data-src={`https://varian.widen.net/content/${image?.external_id}/webp?w=300&h=150&crop=true&quality=40`}
            alt={title}
            title={title}
          />
        </div>
        <h3 className="featured-menu-title">{title}</h3>
        <div className="featured-menu-blurb">{description}</div>
        <span className="featured-link">{linkText}</span>
      </div>
    </a>
  );
};
export default FeaturedMenuItem;
